import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex, Text } from 'rebass';
import { PvCaret } from 'styles/CustomComponents';
import * as resolver from 'table-resolver';

class DriverCardDataTable extends React.Component {
  constructor(props) {
    super(props);

    const columns = [{
      property: 'lessonIndex',
    },
    {
      property: 'lessonTime',
      header: {
        label: <Flex alignItems='right' justifyContent='space-between'><Translate value='driver_card.lesson_time' /><PvCaret /></Flex>,
      },
      cell: {
        formatters: [
          (value, props) => {
            return <Text textAlign='right'>{value}</Text>
          }
        ]
      },
    },
    {
      property: 'lessonDuration',
      header: {
        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.total' /><PvCaret /></Flex>,
      },
      cell: {
        formatters: [
          (value, props) => {
            return <Text textAlign='right'>{value}</Text>
          }
        ]
      },
    },
//    {
//      property: 'guidedTraining',
//      header: {
//        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.guided_training' /><PvCaret /></Flex>,
//      },
//    },
//    {
//      property: 'independentTraining',
//      header: {
//        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.independent_training' /><PvCaret /></Flex>,
//      },
//    },
    {
      property: 'training',
      header: {
        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.training' /><PvCaret /></Flex>,
      },
      props: {
        style: {
          width: 300
        }
      }
    },
    {
      property: 'supervisor',
      header: {
        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.supervisor' /><PvCaret /></Flex>,
      },
    },
    {
      property: 'topics',
      header: {
        label: <Flex alignItems='center' justifyContent='space-between'><Translate value='driver_card.topic' /><PvCaret /></Flex>,
        props: {
          style: {
            width: 420
          }
        }
      },
    }];

    this.state = {
      columns,
      rows: resolver.resolve({columns})(this.props.rows || [])
    };
  }

  render() {

    const {
      stylingRenderers,
      rowKey
    } = this.props;

    const { columns, rows } = this.state;

    return (
      <Table.Provider
        renderers={stylingRenderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={rows} rowKey={rowKey || 'entityId'} />
      </Table.Provider>
    );
  }
}

DriverCardDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  getApplicant: PropTypes.func,
  stylingRenderers: PropTypes.object,
  rowKey: PropTypes.string,
};

export default DriverCardDataTable;


// WEBPACK FOOTER //
// ./src/components/datatable/DriverCardDataTable.jsx